import { find, includes, isFunction, orderBy } from 'lodash';
import React, { useMemo, useState } from 'react';
import EntityForm from '../../../common/components/containers/EntityForm';
import CustomField from '../../../common/components/containers/EntityForm/fields/CustomField';
import SearchField from '../../../common/components/controls/base/SearchField';
import useCurrentUser from '../../../common/data/hooks/useCurrentUser';
import { ModuleByGroups } from '../../Modules';
import ModulesGroupsBar from './ModulesGroupsBar';
const CustomizeQuickAccessBarForm = ({ entity, entityName, onSubmit, accessList, }) => {
    const { me } = useCurrentUser();
    const [searchValue, setSearchValue] = useState('');
    const filteredModules = useMemo(() => ModuleByGroups.reduce((groups, group) => {
        let modules = group.modules.filter(({ title, permission }) => (!searchValue || title.toLowerCase().indexOf(searchValue) !== -1) &&
            (!permission ||
                (isFunction(permission)
                    ? permission(me)
                    : includes(accessList, permission))));
        modules = orderBy(modules, ({ id }) => { var _a; return (_a = find(entity.accessItems, { moduleId: id })) === null || _a === void 0 ? void 0 : _a.sequence; });
        if (modules.length) {
            groups.push({ ...group, modules });
        }
        return groups;
    }, []), [entity.accessItems, accessList, searchValue, me]);
    return (<EntityForm hasResetOnCancel isAlwaysEditable entity={entity} entityName={entityName} isNew={false} successMessageText="Updated Successfully" onSubmit={onSubmit}>
      <SearchField value={searchValue} widthClassName="col-lg-3 col-md-3 col-sm-4 col-xs-6" onChange={setSearchValue}/>
      <CustomField accessList={accessList} columns={1} editComponent={ModulesGroupsBar} groups={filteredModules} label="" name="accessItems" viewComponent={ModulesGroupsBar}/>
    </EntityForm>);
};
export default CustomizeQuickAccessBarForm;
